import { z } from 'zod';
import { Toast, ToastVariant, useToast } from '@hungryroot/components-toast';
import { logUnknownErrorResponse } from '@hungryroot/o11y';

const errorSchema = z.object({
  msg_id: z.string().nullable().optional(),
  detail: z.string().nullable().optional(),
});

export function useErrorMessageToasts() {
  const { toast } = useToast();

  return (e: unknown) => {
    let shouldLogException = true;

    const error = errorSchema.safeParse(e);
    if (error.data?.msg_id === 'cold_volume_exceeded') {
      shouldLogException = false;
      toast(
        <Toast variant={ToastVariant.Critical}>
          Exceeded cold volume limit
        </Toast>
      );
    } else if (error.data?.msg_id === 'total_volume_exceeded') {
      shouldLogException = false;
      toast(
        <Toast variant={ToastVariant.Critical}>
          Exceeded total box volume limit
        </Toast>
      );
    }

    try {
      const detailParsed = JSON.parse(error.data?.detail || '{}');
      if (detailParsed?.pairing?.[0]?.includes('out of stock')) {
        shouldLogException = false;
        toast(
          <Toast variant={ToastVariant.Critical}>
            One or more items are out of stock
          </Toast>
        );
      } else if (
        detailParsed?.pairing?.id?.[0]?.includes('Invalid or inactive')
      ) {
        shouldLogException = false;
        toast(
          <Toast variant={ToastVariant.Critical}>
            Recipe is currently unavailable
          </Toast>
        );
      }
    } catch {
      // noop
    }

    if (shouldLogException) {
      logUnknownErrorResponse('Failed to add to cart', {
        key: 'useErrorMessageToasts',
        error: JSON.stringify(e, null, 2),
      });
    }
  };
}
